var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.774,
    height: 71.286,
    viewBox: "0 0 71.774 71.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5600",
    "data-name": "Group 5600",
    transform: "translate(-1326 -3854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Diagram-Arrow-Up",
    transform: "translate(1329.488 3857)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M0,0H68.286V68.286H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M14.1,12H19.56a4.25,4.25,0,0,1,3.147,1.473,3.883,3.883,0,0,1,.95,2.624V37.949a4.1,4.1,0,0,1-4.1,4.1H14.1a4.1,4.1,0,0,1-4.1-4.1V16.1A4.1,4.1,0,0,1,14.1,12Z",
    transform: "translate(17.314 20.777)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    d: "M7.1,15H12.56a4.1,4.1,0,0,1,4.1,4.1V32.754a4.1,4.1,0,0,1-4.1,4.1H7.1a4.1,4.1,0,0,1-4.1-4.1V19.1A4.1,4.1,0,0,1,7.1,15Z",
    transform: "translate(5.194 25.971)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    "data-name": "path",
    d: "M21.1,9H26.56a4.206,4.206,0,0,1,3.793,2.544,3.714,3.714,0,0,1,.3,1.553V43.143a4.1,4.1,0,0,1-4.1,4.1H21.1a4.1,4.1,0,0,1-4.1-4.1V13.1A4.1,4.1,0,0,1,21.1,9Z",
    transform: "translate(29.434 15.583)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M47.34,6.384,42.174,4.662a1.366,1.366,0,1,1,.864-2.591L51.22,4.8A1.366,1.366,0,0,1,52.1,6.529l-2.731,8.194a1.366,1.366,0,0,1-2.591-.864L48.427,8.9,5,31.887a1.366,1.366,0,1,1-1.278-2.414Z",
    transform: "translate(5.194 3.463)",
    fill: "#fe9920"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Diagram-Arrow-Up-2",
    "data-name": "Diagram-Arrow-Up",
    transform: "translate(1326 3854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    "data-name": "path",
    d: "M0,0H68.286V68.286H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-6",
    "data-name": "path",
    d: "M14.1,14.731A1.366,1.366,0,0,0,12.731,16.1V37.949A1.366,1.366,0,0,0,14.1,39.314H19.56a1.366,1.366,0,0,0,1.366-1.366V16.1a1.366,1.366,0,0,0-1.366-1.366ZM14.1,12H19.56a4.1,4.1,0,0,1,4.1,4.1V37.949a4.1,4.1,0,0,1-4.1,4.1H14.1a4.1,4.1,0,0,1-4.1-4.1V16.1A4.1,4.1,0,0,1,14.1,12Z",
    transform: "translate(17.314 20.777)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    "data-name": "path",
    d: "M7.1,17.731A1.366,1.366,0,0,0,5.731,19.1V32.754A1.366,1.366,0,0,0,7.1,34.12H12.56a1.366,1.366,0,0,0,1.366-1.366V19.1a1.366,1.366,0,0,0-1.366-1.366ZM7.1,15H12.56a4.1,4.1,0,0,1,4.1,4.1V32.754a4.1,4.1,0,0,1-4.1,4.1H7.1a4.1,4.1,0,0,1-4.1-4.1V19.1A4.1,4.1,0,0,1,7.1,15Z",
    transform: "translate(5.194 25.971)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-8",
    "data-name": "path",
    d: "M21.1,11.731A1.366,1.366,0,0,0,19.731,13.1V43.143A1.366,1.366,0,0,0,21.1,44.509H26.56a1.366,1.366,0,0,0,1.366-1.366V13.1a1.366,1.366,0,0,0-1.366-1.366ZM21.1,9H26.56a4.1,4.1,0,0,1,4.1,4.1V43.143a4.1,4.1,0,0,1-4.1,4.1H21.1a4.1,4.1,0,0,1-4.1-4.1V13.1A4.1,4.1,0,0,1,21.1,9Z",
    transform: "translate(29.434 15.583)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-2",
    "data-name": "Combined-Shape",
    d: "M47.34,6.384,42.174,4.662a1.366,1.366,0,1,1,.864-2.591L51.22,4.8A1.366,1.366,0,0,1,52.1,6.529l-2.731,8.194a1.366,1.366,0,0,1-2.591-.864L48.427,8.9,5,31.887a1.366,1.366,0,1,1-1.278-2.414Z",
    transform: "translate(5.194 3.463)",
    fill: "#fd9926"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.531d24cc3de9691a28a5b03eeb44a802.svg";
export { ForwardRef as ReactComponent };